import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListDataPembayaranUkt } from "@/services/getData"

export default function SyncDataPembayaranUktPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listDataPembayaranUkt"],
    queryFn: getListDataPembayaranUkt,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
